<template>
  <img class="circle-loader" alt="loader" src="../../files/assets/pages/Loader.png" />
</template>

<script>
export default {};
</script>

<style scoped>
.circle-loader {
  display: block;
  width: 32px;
  height: 32px;
  animation: rotate 2s infinite linear;
}

@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
